import JSEncrypt from './encryptlong';
import { deepClone } from './index';
export const getEncryptInfo = ({ publicKey = '', payload = {} } = {}) => {
    if (!publicKey)
        return '';
    try {
        const params = deepClone(payload);
        const rsaInstance = new JSEncrypt();
        rsaInstance.setPublicKey(publicKey);
        const encrypted = rsaInstance.encryptLong(typeof params === 'object' ? JSON.stringify(params) : params);
        return encrypted;
    }
    catch (error) {
        console.error('encrypt error:', error);
    }
    return '';
};
